interface StyleConfig {
  key: string;
  title: string;
  description: string;
  additionalProps?: Record<string, any>;
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

interface StyleLayoutItem {
  gridSize: { xs: number; md?: number };
  components: StyleConfig[];
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

export const previewParticipantLevelSentimentAnalyticsStyleLayout: StyleLayoutItem[] = [
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'performance_quadrant',
        title: 'Performance Quadrant',
        description: 'Segment team by quality vs volume',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          xAxisTitle: 'Call Volume',
          yAxisTitle: 'Quality Score',
          xAxisKey: 'call_volume',
          yAxisKey: 'quality_score',
          quadrantKey: 'quadrant',
          tooltipKey: 'tooltip_text',
          xAxisUnit: ' calls',
          yAxisUnit: '',
          showZones: true,
          xAxisAllowDecimals: false,
          yAxisAllowDecimals: true,
          referenceLines: [
            {
              axis: 'x',
              value: 1,
              color: '#94a3b8',
              label: 'Volume Mid'
            },
            {
              axis: 'y',
              value: 31.0,
              color: '#94a3b8',
              label: 'Quality Mid'
            }
          ],
          quadrants: [
            { name: 'star', label: 'Star', color: '#10B981' },
            { name: 'workhorse', label: 'Workhorse', color: '#F59E0B' },
            { name: 'ramping', label: 'Ramping', color: '#3B82F6' },
            { name: 'struggling', label: 'Struggling', color: '#EF4444' }
          ]
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'attention_required',
        title: 'Attention Required',
        description: 'Participants needing immediate attention',
        additionalProps: {
          height: 'auto',
          minHeight: 300,
          showSeverityBadges: true,
          showActionButtons: true,
          expandable: true,
          groupBySeverity: true
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'performance_trend',
        title: 'Performance Trend',
        description: 'Track improvement over time',
        additionalProps: {
          height: 450,
          rowHeight: 16
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'top_performers',
        title: 'Top Performers',
        description: 'Recognition for excellence',
        additionalProps: {
          height: 400,
          rowHeight: 16
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'skill_gap_analysis',
        title: 'Skill Gap Analysis',
        description: 'Team strengths and improvement areas',
        additionalProps: {
          height: 500,
          graphHeight: 400,
          dataKey: 'team',
          color: '#8E79FF',
          fillOpacity: 0.6,
          showLegend: true,
          showDots: true,
          strokeWidth: 2,
          dotSize: 4
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'workload_distribution',
        title: 'Workload Distribution',
        description: 'Call volume and utilization',
        additionalProps: {
          height: 500,
          graphHeight: 380,
          dataKey: 'count',
          xAxisKey: 'range',
          color: '#3B82F6',
          xAxisTitle: 'Call Range',
          yAxisTitle: 'Number of Participants',
          barGap: 0,
          barCategoryGap: '10%'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'customer_satisfaction',
        title: 'Customer Satisfaction Impact',
        description: 'Quality → CSAT Linkage',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          xAxisTitle: 'Quality Score',
          yAxisTitle: 'CSAT Score',
          xAxisKey: 'quality_score',
          yAxisKey: 'csat_score',
          quadrantKey: 'zone',
          tooltipKey: 'tooltip_text',
          xAxisUnit: '',
          yAxisUnit: '',
          showZones: true,
          quadrants: [
            { name: 'attention', label: 'Needs Attention', color: '#EF4444' },
            { name: 'normal', label: 'Normal', color: '#3B82F6' }
          ]
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'improvement_velocity',
        title: 'Improvement Velocity',
        description: 'Rate of performance improvement',
        additionalProps: {
          height: 450,
          rowHeight: 22
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'period_comparison',
        title: 'Period Comparison',
        description: 'Team progress vs last period',
        additionalProps: {}
      }
    ]
  }
];